/* eslint-disable max-len */
var WEATHER_DROP = {
  "default": 'M16,0S6,13.81,6,21,8.81,32,16,32s10-3.81,10-11S16,0,16,0Zm0,30c-5.76,0-8-2.52-8-9,0-4.47,4.84-12.73,8-17.48,3.16,4.75,8,13,8,17.48C24,27.48,21.76,30,16,30Z',
  globetrotter: 'M24 21.5C24 25.92 20.42 29.5 16 29.5C11.58 29.5 8 25.92 8 21.5C8 17.08 16 2.5 16 2.5C16 2.5 24 17.08 24 21.5Z'
};

export { WEATHER_DROP };
//# sourceMappingURL=WEATHER_DROP.js.map
